import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import * as accountServices from '../services/accountService'
class CreditStatement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statement: []
        };
    }
    componentDidMount() {
        accountServices.getCreditData().then((res) => {
            if (res.length > 0) {
                this.setState({ statement: res })
            }
        })
    }
    render() {
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className="wrapper">
                    <UserMenu history={this.props.history} />
                    <div className="content-page ">
                        <span style={{ color: "red" }}>This is only Layout Design of Page.</span>
                        <div className="l-flex main-menu-box">
                            <div className="l-fg3">
                                <div className="main-menu-play">
                                    <div className="row">
                                        <div className="col-12"><div className="menu-title">Credit Statement</div></div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-12 col-sm-12 col-md-12 mt-4">
                                            <div className="dt-responsive table-responsive account-statment">
                                                <table id="basic-btn" className="table table-striped table-bordered nowrap table-sm  ">
                                                    <thead>
                                                        <tr className="bg-dark text-white">
                                                            <th>S.No</th>
                                                            <th>Date</th>
                                                            <th>Credit In</th>
                                                            <th>Credit Out</th>
                                                            <th>Credit</th>
                                                            <th>Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="tblAccountStatement">
                                                        {this.state.statement.length > 0 && this.state.statement.map((entry, i) => {
                                                            return (
                                                                <tr data-toggle="modal" data-target="#myModal">
                                                                    <td>{i + 1}</td>
                                                                    <td>{new Date(entry.createdAt).toUTCString()}</td>
                                                                    <td>{entry.type === 'CREDIT' ? entry.amount : ""}</td>
                                                                    <td>{entry.type === 'DEBIT' ? entry.amount : ""}</td>
                                                                    <td>{entry.type === 'CREDIT' ? entry.amount : (0 - entry.amount)}</td>
                                                                    <td>{entry.description}</td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditStatement);